import { StatusCodes } from 'http-status-codes';

export const BAD_AUTH_DATA_CODES = [StatusCodes.FORBIDDEN, StatusCodes.UNAUTHORIZED];
